module.exports = __webpack_public_path__ + "img/11.6e1cfc33.png";